import { MapGroupId } from "../../types";
import img from "../../mapImages/InterchangeMainOld.webp";

const mapData = {
  groupId: MapGroupId.Interchange,
  groupName: {
    en: "Interchange",
    ru: "Развязка",
  },
  title: {
    en: "Main (Old)",
    ru: "Главная (Старая)",
  },
  imgPath: img,
  extracts: [],
};

export default mapData;
